import React, { FunctionComponent as FC } from 'react';
import './index.scss';

import VerifyEmail from './VerifyForm';

interface VerifyEmailPageProps {

}

const VerifyEmailPage: FC<VerifyEmailPageProps> = (props) => {

  const {
  } = props

  return (
    <div className='verify-email-page-div'>
      <VerifyEmail />
    </div>

  )
}

export default VerifyEmailPage